<template>
  <div>
    <el-row style="flex-wrap:wrap;" justify="center" align="middle"
      v-show="questionInfo.eqType != 9"
    >
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="">
        <el-form-item  label="" label-width="80px" prop="">
          <el-radio-group v-model="value.IF_RIGHT"
            :disabled="(showType == 4 && (questionInfo.eqType!=1 && questionInfo.eqType!=2 && questionInfo.eqType!=3
              && questionInfo.eqType!=10
            ))?false:true"
            @change="ifRightChange"
          >
            <el-radio :label="'1'" style="display: inline-block;">对</el-radio>
            <el-radio :label="'2'" style="display: inline-block;">错</el-radio>
            <el-radio :label="'3'" style="display: inline-block;">部分对</el-radio>
          </el-radio-group>
          <el-input v-model="value.GET_SCORE" style="width:200px;"
            :disabled="(showType == 4 && (questionInfo.eqType!=1 && questionInfo.eqType!=2 && questionInfo.eqType!=3
              && questionInfo.eqType!=10)
              && (value.getScoreIfChange!=1))?false:true"
            @change="emitGetScoreChange"
          >
            <template slot="append">最大分:{{questionInfo.eqScore}}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item  label="批改备注" label-width="80px" prop="CHECK_REMARK">
          <el-input style="width:80%;" 
            v-model="value.CHECK_REMARK"
            suffix-icon="el-icon-document"
            :disabled="(showType == 4)?false:true"
            type="textarea"
          >
            <template slot="prepend">点评</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DoQuestionAppraise',
  props: {
    questionInfo:{
      type:Object,
      default:{}
    },
    value:{
      type:Object,
      default:{}
    },
    showType:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    this.$set(this.value,"getScoreIfChange",1);
  },
  mounted() {
    
  },
  components: {
  },
  computed: {
  },
  methods: {
    /**
     * 批改试卷时 切换对错时 进行分数的切换
     */
    ifRightChange(ifRight){
      if(ifRight == "1") {
        this.value.GET_SCORE = this.questionInfo.eqScore+"";
        this.$set(this.value,"getScoreIfChange",1);
      } else if(ifRight == "2") {
        this.value.GET_SCORE = "0";
        this.$set(this.value,"getScoreIfChange",1);
      } else {
        this.value.GET_SCORE = "";
        //设置为可编辑
        this.$set(this.value,"getScoreIfChange",0);
      }
      this.$emit("getScoreChange");
    },
    emitGetScoreChange(){
      this.$emit("getScoreChange");
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
